'use strict';

import { cn_contour } from '..';
import { cn_layer } from './cn_layer';

export class cn_zpso extends cn_layer {
    //*******************************************************
    /**
     * Constructor
     */
    constructor(name = '') {
        super(name);
        this.class_name = 'cn_zpso';
        this.control_result = '';
        this.type = '';
        this.decision_criteria = '';
    }


    //*******************************************************
    /**
     * serialize
     * @returns {object} json object
     */
    serialize_with_building(building) {
        const json = super.serialize_with_building(building);
        json.control_result = this.control_result;
        json.type = this.type;
        json.decision_criteria = this.decision_criteria;
        return json;
    }

    //*******************************************************
    /**
     * unserialize
     * @returns {object} zpso object
     */
    static unserialize(json, building = null) {
        const result = new cn_zpso(json.name);
        result.unserialize_element(json);
        result.elements = [...(json.elements || [])];
        result.color = json.color || '';
        if (json.opacity && typeof (json.opacity) == 'number')
            result.opacity = json.opacity;
        result.stripes = json.stripes || '';
        result.control_result = json.control_result || '';
        result.type = json.type;
        result.decision_criteria = json.decision_criteria;
        result.sections = [...(json.sections || [])];
        result.elements_types = [...(json.elements_types || [])];
        result.description = json.description;
        if (building) {
            if (json.sections) {
                result.sections = [...json.sections.map(section => {
                    return {
                        shape: cn_contour.unserialize(section.shape, building.storeys.find(storey => storey.ID === section.storey)),
                        storey: section.storey,
                        support: section.support,
                        obj: section.obj,
                        order: section.order || 1
                    }
                })];
            } else {
                result.sections = [];
            }
            if (json.lines) {
                result.lines = [...json.lines.map(line => {
                    return {
                        shape: cn_contour.unserialize(line.shape, building.storeys.find(storey => storey.ID === line.storey)),
                        line: [...line.line],
                        storey: line.storey,
                        support: line.support,
                        obj: line.obj,
                        order: line.order || 1
                    }
                })];
            }
        }
        return result;
    }
}
